module.exports = __webpack_public_path__ + "static/job-training-a9b8722122b4d24c72f3a64c1314ca46.jpg";